import React from 'react';

const Landing = () => {
  return (
    <div className="min-h-screen bg-white flex items-center">
      {/* Main Content */}
      <div className="container max-w-3xl mx-auto py-20 px-4">
        <div className="space-y-16">
          {/* Title Section - Centered */}
          <div className="text-center space-y-4">
            <p className="text-sm font-medium text-blue-600 uppercase tracking-wider">
              BrightLight Health
            </p>
            <h1 className="text-4xl md:text-5xl font-light text-gray-900 leading-tight tracking-tight">
              Virtual Consultation Platform
            </h1>
            <p className="text-base font-light text-gray-600 max-w-xl mx-auto leading-relaxed">
              Connect with your healthcare clinician through secure video consultations.
              Use the meeting link provided by your clinic to join your appointment.
            </p>
          </div>

          {/* Instructions Box - White background with border */}
          <div className="bg-white p-8 rounded-lg border border-gray-200 max-w-xl mx-auto w-full">
            <div className="space-y-5">
              <h2 className="text-base font-medium text-gray-900">
                To Join Your Appointment
              </h2>

              <div className="space-y-3">
                <div className="flex gap-3 items-start">
                  <div className="min-w-[20px] h-5 bg-blue-600 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <span className="text-xs font-medium text-white">1</span>
                  </div>
                  <p className="text-gray-700 text-sm font-light">
                    Check your email for the appointment confirmation
                  </p>
                </div>

                <div className="flex gap-3 items-start">
                  <div className="min-w-[20px] h-5 bg-blue-600 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <span className="text-xs font-medium text-white">2</span>
                  </div>
                  <p className="text-gray-700 text-sm font-light">
                    Click the meeting link provided
                  </p>
                </div>

                <div className="flex gap-3 items-start">
                  <div className="min-w-[20px] h-5 bg-blue-600 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <span className="text-xs font-medium text-white">3</span>
                  </div>
                  <p className="text-gray-700 text-sm font-light">
                    Wait for your clinician to admit you
                  </p>
                </div>
              </div>

              <div className="bg-gray-50 p-3 rounded-md mt-2">
                {/*
                  Read from the address bar rather than written out. This line
                  said `meet.brightlight.ai` while the page it was on served
                  `meeting.brightlight.ai` — the host moved when the app came
                  in-house and the sentence describing it did not. Derived from
                  window.location it cannot drift again, and a patient on any
                  hostname is told the one they are actually on.
                */}
                <p className="text-xs text-gray-600 font-light">
                  Meeting links follow this format: {window.location.host}/your-meeting-code
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Landing;